import { createSelector } from "reselect";

//Payload Generator
import { createLatestEventGetPayload } from "src/api/events/payload_generators";

// Utils
import { buildQueryString } from "src/utils/build_query_string";

/**
 * create a selector to get the api query for the latest locked event with a revisionId
 * @param {Object} props
 * @param {string} props.revisionId
 * @returns {function} selector
 */
export function createLatestLockedEventForRevisionIdQuerySelector({
  revisionId
}) {
  return createSelector(() => {
    return buildQueryString(
      createLatestEventGetPayload({
        revisionId,
        eventType: "lock"
      })
    );
  });
}
